import { Formik } from 'formik';
import type { FormikProps } from 'formik';
import { boolean, object } from 'yup';

import { useUpdateOrderTableSettings } from '@frontend/api';
import type { OrderTableSettingsData } from '@frontend/api';
import { CheckboxGroup } from '@frontend/components';

import { TableSettingsForm } from 'components/listTablePage';

import { CheckboxField } from './CheckboxField';

export type OrderTableSettingsFormProps = {
  onCloseSettingsPopover: () => void;
  userId: string;
  settings: OrderTableSettingsData;
};

export const OrderTableSettingsForm = ({
  onCloseSettingsPopover,
  userId,
  settings,
}: OrderTableSettingsFormProps) => {
  const {
    orderNumber,
    account,
    contact,
    salesperson,
    price,
    orderedOn,
    shipsOn,
    deliverBy,
    payment,
    po,
  } = settings;

  const { mutate: updateSettings, isLoading: isUpdating } =
    useUpdateOrderTableSettings(
      { userId },
      { queryOptions: { onSettled: onCloseSettingsPopover } },
    );

  const onSubmit = (values: OrderTableSettingsData) => {
    updateSettings(values);
  };

  return (
    <Formik
      initialValues={{
        orderNumber,
        account,
        contact,
        salesperson,
        price,
        orderedOn,
        shipsOn,
        deliverBy,
        payment,
        po,
      }}
      validationSchema={object().shape({
        orderNumber: boolean().required(),
        account: boolean().required(),
        contact: boolean().required(),
        salesperson: boolean().required(),
        price: boolean().required(),
        orderedOn: boolean().required(),
        shipsOn: boolean().required(),
        deliverBy: boolean().required(),
        payment: boolean().required(),
        po: boolean().required(),
      })}
      onSubmit={onSubmit}
    >
      {(props: FormikProps<OrderTableSettingsData>) => {
        return (
          <TableSettingsForm
            formikProps={props}
            onClose={onCloseSettingsPopover}
            isUpdating={isUpdating}
          >
            <CheckboxGroup>
              <CheckboxField name={'orderNumber'} text={'Order Number'} />
              <CheckboxField name={'account'} text={'Account'} />
              <CheckboxField name={'contact'} text={'Contact'} />
              <CheckboxField name={'salesperson'} text={'Salesperson'} />
              <CheckboxField name={'price'} text={'Price'} />
              <CheckboxField name={'orderedOn'} text={'Ordered On'} />
              <CheckboxField name={'shipsOn'} text={'Ships On'} />
              <CheckboxField name={'deliverBy'} text={'Deliver By'} />
              <CheckboxField name={'payment'} text={'Payment'} />
              <CheckboxField name={'po'} text={'PO'} />
            </CheckboxGroup>
          </TableSettingsForm>
        );
      }}
    </Formik>
  );
};
